import {
  MonitoredCycleTime,
  MonitoredCycleTimeCreateRequest,
  MonitoredCycleTimeUpdateRequest,
} from '../../types/app/monitoredCycleTime.types';
import { api } from '../core/api';

export const getMonitoredCycleTimesByDep = (departmentId: number) =>
  api
    .get<MonitoredCycleTime[]>(`MonitoredCycleTime/GetList/?parentId=${departmentId}`)
    .then((res) => res.data);

export const getMonitoredCycleTime = (id: number) =>
  api.get<MonitoredCycleTime>(`MonitoredCycleTime/GetItem/?id=${id}`).then((res) => res.data);

export const updateMonitoredCycleTime = (data: MonitoredCycleTimeUpdateRequest) =>
  api.put(`MonitoredCycleTime/UpdateItem`, data).then((res) => res.data);

export const createMonitoredCycleTime = (data: MonitoredCycleTimeCreateRequest) =>
  api.post(`MonitoredCycleTime/CreateItem`, data).then((res) => res.data);

export const deleteMonitoredCycleTime = (id: number) =>
  api.delete<MonitoredCycleTime>(`MonitoredCycleTime/DeleteItem/?id=${id}`).then();

export const getCount = (parentId?: number) =>
  api
    .get<number>(`MonitoredCycleTime/GetCount` + (parentId ? `?parentId=${parentId}` : ''))
    .then((res) => res.data);
